var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scoped-rich-text-editor-content-display",domProps:{"innerHTML":_vm._s(_vm.urlify(_vm.text))}})
}
var staticRenderFns = []

export { render, staticRenderFns }